import {APP_LANGUAGE_SUPPORTS} from '@/shared/lib/appLanguageSupports';

/**
 * Language for a prerendered path, taken from the `($lang)` segment. `init`
 * reads the same segment on the client through the `path` detector, so both
 * sides of the hydration agree.
 *
 * Returns `fallback` when the path carries no supported language segment, so
 * callers that need to tell "no language in the URL" apart from an explicit
 * `/en/...` can omit it and check for `undefined`.
 */
export function getLanguageFromUrl(url: string): string | undefined {
  const [segment] = new URL(url).pathname.split('/').filter(Boolean);

  if (segment && segment in APP_LANGUAGE_SUPPORTS) {
    return segment;
  }
}
